import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {useEffect, useRef, useState} from "react";
// -
import TableCheckboxAssets from "./TableCheckboxAssets";
import axiApi from "ApiCaller";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import {publishEvent} from "core/eventsConnector";
import {useTranslation} from "react-i18next";


const ModalAssetsSelectSimple = ({show, setShow, multiple = false, chosenIn = [], subtitle = "", filtering = {}}) => {
    const [_Tc] = useTranslation("choices")
    const items = useRef({
        all: [],
        showed: [],
        chosen: [],
        checked: []
    })
    const [checked, setChecked] = useState([])
    const [itemsShow, setItemsShow] = useState([]);
    useEffect(() => {
        if (chosenIn.length) {
            items.current.checked = chosenIn.map(it => it.id);
            setChecked([...items.current.checked]);
            setItemsShow([...items.current.all]);
        }
    }, [chosenIn])

    useEffect(() => {
        let params = {}
        if (Object.keys(filtering).length) {
            let key;
            for (key in filtering) {
                params[key] = filtering[key];
            }
        }
        axiApi.get("/api/assets/simple/", {params: params}).then((resp) => {
            items.current.all = [...resp.data.items];
            items.current.showed = [...resp.data.items];
            items.current.checked = chosenIn.map(it => it.id);
            setItemsShow([...resp.data.items]);
        });
    }, []);

    const onSearch = (e) => {
        let items_ = items.current.all.filter(it => items.current.checked.includes(it.id));
        const valueSearched = toLowCaseCleanSpaces(e.target.value);
        if (valueSearched) {
            let filter_ = items.current.all.filter((_item) => {
                    let word = toLowCaseCleanSpaces(_item.uid);
                    word += toLowCaseCleanSpaces(_item.uuids);
                    word += toLowCaseCleanSpaces(_item.full_address);
                    return word.includes(valueSearched) && !items.current.checked.includes(_item.id);
                }
            )
            items.current.showed = [...items_, ...filter_];
        } else {
            items.current.showed = [...items.current.all];
        }
        setItemsShow([...items.current.showed]);
    };


    const handleClose = () => {
        setShow(false);
    }
    const handleAccept = () => {
        setShow(false);
        if (multiple) {
            let items_ = items.current.all.filter(item => items.current.checked.includes(item.id));
            publishEvent("assetsimple:modalselect:change", items_)
        }
        items.current.showed = [...items.current.all];
        setItemsShow([...items.current.showed]);
    }

    const getNameFilterings = (key, index) => {
        let name = ""
        switch (key) {
            case "waste_type":
                name = _Tc("wastes." + filtering[key])
                break;
            case "download_type":
                name = _Tc("downloads." + filtering[key])
                break;
            default:
                name = filtering[key]
        }
        return <span key={index} className="badge bg-secondary ms-2">{name}</span>
    }

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} dialogClassName="modal-dialog-scrollable" size="lg">
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="dumpster"/>
                    </div>
                    <div className="preview-title d-inline-flex align-items-center">
                        <Modal.Title className="d-inline-flex ms-1">
                            <div>
                                <div className="h4 ms-0">
                                    Contenedores
                                </div>
                                <div className="h5 ms-0">
                                    <small>{subtitle}</small>
                                </div>
                            </div>
                        </Modal.Title>
                        <form className="d-inline-flex ms-2" role="search">
                            <input className="form-control border-end-0 rounded-0" type="search"
                                   placeholder="uid, uuid, dirección"
                                   aria-label="Search"
                                   onChange={onSearch}
                            />
                            <span className="input-group-text bg-white border-start-0 rounded-0"
                                  id="modal-searcher-groups">
                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass"/>
                            </span>
                        </form>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {
                        Object.keys(filtering).length
                            ? <div className="row">
                                <div className="col-12 d-inline-flex align-items-center">
                                    <span>Filtros:</span> {
                                    Object.keys(filtering).map((key, index) => getNameFilterings(key, index))
                                }
                                </div>
                            </div>
                            : <></>
                    }

                    <TableCheckboxAssets
                        items={items}
                        itemsShow={itemsShow}
                        checked={checked}
                        setChecked={setChecked}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Descartar
                    </Button>
                    <Button variant="primary" onClick={handleAccept}>
                        Seleccionar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );


}

export default ModalAssetsSelectSimple